import { render, staticRenderFns } from "./DailyInner.vue?vue&type=template&id=23e48df5&scoped=true"
import script from "./DailyInner.vue?vue&type=script&lang=js"
export * from "./DailyInner.vue?vue&type=script&lang=js"
import style0 from "./DailyInner.vue?vue&type=style&index=0&id=23e48df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e48df5",
  null
  
)

export default component.exports